import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-qclist-abstracts',
  templateUrl: './qclist-abstracts.component.html',
  styleUrls: ['./qclist-abstracts.component.css'],
  imports: []
})
export class QclistAbstractsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
